import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  rtnRcptSync01ShowSyncSetting: null,
  rtnRcptSync01ShowSyncSettingLoading: ['boolean'],
  rtnRcptSync01ShowSyncSettingSuccess: ['syncSetting'],
  rtnRcptSync01UpdateSyncSetting: ['formikBag', 'syncSetting'],
  rtnRcptSync01ShowBatchJobStatus: null,
  rtnRcptSync01ShowBatchJobStatusSuccess: ['batchJobStatus'],
  // rtnRcptSync01SyncNow: ['formikBag', 'divisionId'],
  // rtnRcptSync01SyncLoading: ['boolean'],

  rtnRcptSync01ResetTimestamp: ['currentPage', 'sorts', 'filters', 'pageSize'],
  rtnRcptSync01GoToDocument: ['hdrId'],
  rtnRcptSync01FetchRtnRcptSync01: ['currentPage', 'sorts', 'filters', 'pageSize'],
  rtnRcptSync01FetchRtnRcptSync01Loading: ['boolean'],
  rtnRcptSync01FetchRtnRcptSync01Success: [
    'documents',
    'currentPage',
    'lastPage',
    'total',
    'pageSize'
  ],
  rtnRcptSync01AddSelectedDocuments: ['selectedDocuments'],
  rtnRcptSync01RemoveSelectedDocuments: ['selectedDocuments'],
  rtnRcptSync01SetWorkspaceVisible: ['boolean'],

  rtnRcptSync01SyncNow: ['hdrIds'],
  rtnRcptSync01SyncNowSuccess: null,
  rtnRcptSync01SyncLoading: ['boolean']
});

export const RtnRcptSync01Types = Types;
export default Creators;
